<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Agent Detail</p>
    </header>
    <section class="modal-card-body">
      <div>
        <h3 class="title">{{ agent.name }}</h3>
        <div>
          <span>{{ agent.email }}</span>
        </div>
        <div>
          <span>{{ agent.number }}</span>
        </div>
        <div>
          <span>Max Limit: {{ agent.limit }}</span>
        </div>
        <div>
          <strong>Total Sales: {{ hisCards().length }}</strong>
        </div>
        <div style="margin-top:20px;" class="columns" >
          <div
            v-for="card in hisCards()"
            :key="card.number"
            style="margin: 2px; border-radius: 5px"
            class="has-background-light column"
          >
            {{ card.number }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["agent"],
  computed: {
    ...mapState(["cards"]),
  },
  methods: {
    hisCards() {
      return this.cards.filter((card) => card.agent == this.agent.email);
    },
  },
};
</script>